import './news-author.scss';

/**
 * version    1.0
 * class      <type> (news author)
 * classdesc  Component that manage the news author information
 */
export class NewsAuthor {}
